import { Box } from '@bpba/ui-components';
import { BiMinusCircle, BiPlusCircle } from 'react-icons/bi';
import { IconedLabel } from './IconedLabel';
import styled from 'styled-components';

export type InvitadosControlsProps = {
  cantInvitados: number;
  cantMaxInvitados: number;
  addInvitado: () => void;
  sliceInvitado: () => void;
};

export const InvitadosControls = (props: InvitadosControlsProps) => {
  return (
    <Box justifyContent={'space-between'} marginY={'15px'}>
      {props.cantInvitados < props.cantMaxInvitados ? (
        <StyledIconedLabel text="Agregar Invitada/o" inverse={true} onClick={() => props.addInvitado()}>
          <BiPlusCircle fontSize={'20px'} />
        </StyledIconedLabel>
      ) : (
        <span />
      )}
      {props.cantInvitados > 0 ? (
        <StyledIconedLabel text="Quitar Invitada/o" inverse={false} onClick={() => props.sliceInvitado()}>
          <BiMinusCircle fontSize={'20px'} />
        </StyledIconedLabel>
      ) : (
        <span />
      )}
    </Box>
  );
};

const StyledIconedLabel = styled(IconedLabel)({
  cursor: 'pointer',
  userSelect: 'none',
  '&:hover': {
    opacity: '0.7',
  },
});
